import angular from 'angular';

angular.module('ll').component('desktopMenu', {
  transclude: true,
  template: '<div layout="column" style="margin: 8px" class="boxed-component"><ng-transclude></ng-transclude></div>'
});
